/* "Completa el look": sugerencias en el cart drawer. Usa la API de recomendaciones de Shopify y, si no hay, lo mas nuevo de la tienda. */
if (!customElements.get('cart-recs')) {
  class CartRecs extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      if (!productId) return;

      this.inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
      this.slot = this.querySelector('.cart-recs__slot');
      if (!this.slot) return;

      // El drawer se re-renderiza en cada cambio del carrito: guardamos el resultado para no repetir la peticion
      window.__cartRecs = window.__cartRecs || {};
      const cache = window.__cartRecs;

      if (cache[productId]) {
        this.render(cache[productId]);
        return;
      }

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // En un theme sin publicar (preview) hay que indicarlo para que la API use el theme correcto
      const theme = window.Shopify && Shopify.theme;
      const preview = theme && theme.role && theme.role !== 'main' ? '&preview_theme_id=' + theme.id : '';

      const recsUrl =
        root +
        'recommendations/products?section_id=cart-recommendations&product_id=' +
        encodeURIComponent(productId) +
        '&limit=8&intent=related' +
        preview;
      const fallbackUrl = root + 'collections/shop-all?section_id=cart-recommendations' + preview;

      const load = (url) =>
        fetch(url)
          .then((response) => (response.ok ? response.text() : ''))
          .catch(() => '');

      load(recsUrl)
        .then((html) => (this.hasCards(html) ? html : load(fallbackUrl)))
        .then((html) => {
          cache[productId] = html;
          this.render(html);
        });
    }

    hasCards(html) {
      if (!html) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelectorAll('.cart-recs__card').length > 0;
    }

    render(html) {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const list = doc.querySelector('.cart-recs__list');
      if (!list) return;

      // Quitamos lo que ya esta en el carrito y dejamos maximo 4
      Array.from(list.querySelectorAll('.cart-recs__card')).forEach((card) => {
        if (this.inCart.includes(card.dataset.handle)) card.remove();
      });
      const remaining = Array.from(list.querySelectorAll('.cart-recs__card'));
      remaining.slice(4).forEach((card) => card.remove());
      if (!remaining.length) return;

      this.slot.innerHTML = '';
      this.slot.appendChild(document.importNode(list, true));
      this.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
    }
  }

  customElements.define('cart-recs', CartRecs);
}